import { useState } from "react";
import { format } from "date-fns";
import { Box } from "@mui/material";
import MuiDatePicker from "../../../Common/FormInputs/MuiDatePicker";
import AppButton from "../../../Common/Button/Button";
import Alert from "../../../layout/Alert";
import "./DACCount.css";

const DACCount = ({ dacData, getDACCount }) => {
    const [startDateFilter, setStartDateFilter] = useState(null);
    const [endDateFilter, setEndDateFilter] = useState(null);
    const [showDACData, setShowDACData] = useState(false);

    const handleStartDateChange = (date) => {
        setStartDateFilter(date ? date.getTime() : null);
        setEndDateFilter(null);
        setShowDACData(false);
    };
    const handleEndDateChange = (date) => {
        setEndDateFilter(date ? date.getTime() : null);
        setShowDACData(false);
    };
    const filter = () => {
        setShowDACData(false);
        const startDate = format(new Date(Number(startDateFilter)), "dd-MM-yyyy");
        const endDate = format(new Date(Number(endDateFilter)), "dd-MM-yyyy");
        getDACCount({ startTs: startDate, endTs: endDate }, () => setShowDACData(true));
    };

    return (
        <Box sx={{ width: "100%", minWidth: 0 }}>
            <Box className="content-block bottom-shadow dac-count-filter">
                <Box className="py-15 dac-count-filter-row">
                    <div className="dac-count-filter-group">
                        <Box component="label" className="dac-count-filter-label">From:</Box>
                        <Box sx={{ width: 180, minWidth: 140, maxWidth: 180 }}>
                            <MuiDatePicker
                                label="Start Date"
                                value={startDateFilter ? new Date(startDateFilter) : null}
                                maxDate={new Date()}
                                onChange={handleStartDateChange}
                            />
                        </Box>
                    </div>
                    <div className="dac-count-filter-group dac-count-filter-group-to">
                        <Box component="label" className="dac-count-filter-label">To:</Box>
                        <Box sx={{ width: 180, minWidth: 140, maxWidth: 180 }}>
                            <MuiDatePicker
                                label="End Date"
                                value={endDateFilter ? new Date(endDateFilter) : null}
                                minDate={startDateFilter ? new Date(startDateFilter) : undefined}
                                maxDate={new Date()}
                                onChange={handleEndDateChange}
                            />
                        </Box>
                    </div>
                    <div className="dac-count-filter-btn-wrap">
                        <AppButton
                            variant="primary"
                            size="medium"
                            onClick={filter}
                            disabled={startDateFilter === null || endDateFilter === null}
                            sx={{ minWidth: 80, height: 40 }}
                        >
                            Filter
                        </AppButton>
                    </div>
                </Box>
            </Box>
            <Alert />
            {showDACData && (
                <Box className="content-block bottom-shadow" sx={{ mt: 1 }}>
                    <Box className="page-title" sx={{ m: 1, ml: 2 }}>
                        <Box component="h3" sx={{ m: 0 }}>{`DAC Count : ${dacData?.hasOwnProperty("count") ? dacData?.count : "-"}`}</Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default DACCount